import React from 'react'
import {
  BadgeColorEnum,
  BadgeShapeEnum,
  BadgeSizeEnum,
} from 'src/editor/shared/ui-lib/shared/badge-consts'
import {
  getCircleColorClasses,
  getCloseButtonClasses,
  getColorClasses,
  getShapeClasses,
  getSizeClasses,
} from 'src/editor/shared/ui-lib/utils/badge-utils'
import { twMerge } from 'tailwind-merge'
import { XCircleFillIcon } from '../../icons/x-circle-fill-icon'

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: BadgeSizeEnum
  shape?: BadgeShapeEnum
  color?: BadgeColorEnum
  withCircle?: boolean
  children: React.ReactNode
  closeButtonProps?: React.HTMLAttributes<SVGSVGElement>
  withoutCloseButton?: boolean
}

// TODO: extend it https://www.figma.com/design/bGbln5WpRxSxWaY8I4MLkX/Systeme.io-Design-System?node-id=3139-4329&m=dev
export const Badge = ({
  children,
  className,
  size = BadgeSizeEnum.Medium,
  shape = BadgeShapeEnum.Rounded,
  color = BadgeColorEnum.Gray,
  withCircle,
  withoutCloseButton,
  closeButtonProps,
  ...props
}: BadgeProps) => {
  return (
    <div
      className={twMerge(
        'flex w-fit items-center gap-1.5',
        getSizeClasses(size),
        getShapeClasses(shape),
        getColorClasses(color),
        className,
      )}
      {...props}
    >
      {withCircle && (
        <div
          className={twMerge(
            'h-1.5 w-1.5 rounded-full',
            getCircleColorClasses(color),
          )}
        />
      )}
      <span>{children}</span>
      {closeButtonProps && !withoutCloseButton && (
        <XCircleFillIcon
          className={twMerge(
            'h-4 w-4 cursor-pointer',
            getCloseButtonClasses(color),
          )}
          {...closeButtonProps}
        />
      )}
    </div>
  )
}
